/* eslint-disable */
/**
 * MockAnalyticsService
 * @class MockAnalyticsService
 */
class MockAnalyticsService {
  /**
   * The `AnalyticsServiceAdapterContract` interface that will be used for connecting to varius analytics platforms
   * @type {AnalyticsServiceAdapterContract}
   * @memberof MockAnalyticsService
   */
  analyticsAdapter;

  /**
   * Creates an instance of `MockAnalyticsService`
   * @param {AnalyticsServiceCreateDto} dto The params required to create an instance of `MockAnalyticsService`
   * @memberof MockAnalyticsService
   */
  constructor({ analyticsAdapter }) {
    this.analyticsAdapter = analyticsAdapter;
  }

  /**
   * Add an Analytics script to the page
   * @returns {void} void
   * @memberof AnalyticsAdapter
   */
  addScript = () => {
    return this.analyticsAdapter.addScript();
  };

  /**
   * Track an event
   * @param {AnalyticsEvent} event The event to track
   * @returns {void} void
   * @memberof MockAnalyticsService
   */
  track = (event) => {
    return this.analyticsAdapter.track(event);
  };
}

export default MockAnalyticsService;
